import { render, staticRenderFns } from "./CategoryTypeEdit.vue?vue&type=template&id=5fd0166a"
import script from "./CategoryTypeEdit.vue?vue&type=script&lang=js"
export * from "./CategoryTypeEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports